/* 

// Create a new element, like so:

const detail = new Element('div', {
  id: 'dt-detail',
  class: 'embed__detail',
  innerHTML: 'TEST',
});

*/

export default class Element {
  constructor(tag, attributes) {
    const el = document.createElement(tag);
    for (const property in attributes) {
      if (property === 'class') {
        el['className'] = attributes['class'];
      } else {
        el[property] = attributes[property];
      }
    }
    return el;
  }
}